import { render, staticRenderFns } from "./TrademarkSearchHistoryForm.vue?vue&type=template&id=76589470&"
import script from "./TrademarkSearchHistoryForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkSearchHistoryForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkSearchHistoryForm.vue?vue&type=style&index=0&id=76589470&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports